import type { Contact } from "../types";

/**
 * Display name for a contact. Names are optional — email is the identity
 * anchor and many form signups arrive email-only — so fall back to the email
 * rather than rendering "null null" or a blank row.
 */
export const contactName = (
  contact: Pick<Contact, "first_name" | "last_name" | "email"> | undefined,
): string =>
  [contact?.first_name, contact?.last_name].filter(Boolean).join(" ") ||
  contact?.email ||
  "—";
